var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgImoveis = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01146 20.427V12.8185L3.62588 12.7504C1.76657 12.4225 1.23183 10.0105 2.77866 8.92793L11.8485 2.5769C12.8072 1.90571 14.1284 2.13881 14.8 3.09722L21.1511 12.1678C22.0188 13.4076 21.3355 15.0512 20.001 15.4252V20.427C20.001 21.4287 19.2252 22.2515 18.2522 22.2515H5.76096C4.78794 22.2515 4.01146 21.4287 4.01146 20.427ZM19.001 14.5229L19.4791 14.502C20.3352 14.4646 20.8414 13.4693 20.3319 12.7413L13.981 3.67096C13.6262 3.16474 12.9283 3.04161 12.422 3.39607L3.35216 9.74714C2.53527 10.3189 2.81762 11.5924 3.79963 11.7656L5.01146 11.9795V20.427C5.01146 20.8889 5.3536 21.2515 5.76096 21.2515H7.29699L8.57705 14.0097C8.76813 12.9223 9.80615 12.1953 10.8934 12.3874L13.8485 12.9086C14.9356 13.1006 15.6614 14.1375 15.4704 15.2257L14.4058 21.2515H18.2522C18.6593 21.2515 19.001 20.8892 19.001 20.427V14.5229ZM14.4855 15.0523L13.3906 21.25H8.31276L9.56188 14.1833C9.6574 13.6397 10.1764 13.2762 10.7195 13.3721L13.6747 13.8934C14.218 13.9894 14.5811 14.508 14.4855 15.0523Z",
    fill: props.color || 'currentColor'
  }));
};
export default SvgImoveis;